import axios from "axios";
import { getCookie } from "../utils/cookieUtils";

const pricingApiBaseUrl = import.meta.env.VITE_PRICING_API;

const pricingApi = axios.create({
  baseURL: pricingApiBaseUrl,
});

pricingApi.interceptors.request.use((config) => {
  const token = getCookie("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export interface PurchaseResponse {
  token: string;
  subtotal: number;
  tax: number;
  total: number;
  broker_fee: number;
  broker_fee_tax: number;
  broker_fee_total: number;
  total_charge: number;
  country: string;
  created_at: string;
  valid_until: string;
  validated: boolean;
}

export interface DonationResponse {
  token: string;
  donation_subtotal: number;
  donation_fee_rate: number;
  donation_fee: number;
  donation_fee_tax: number;
  donation_fee_total: number;
  broker_fee: number;
  broker_fee_tax: number;
  broker_fee_total: number;
  total_charge: number;
  created_at: string;
  valid_until: string;
  validated: boolean;
}

export const calculatePurchase = async (
  country: string
): Promise<PurchaseResponse> => {
  try {
    const response = await pricingApi.post<PurchaseResponse>("/api/purchase", {
      country,
    });
    return response.data;
  } catch (error) {
    console.error("Error calculating purchase", error);
    throw new Error("Failed to calculate purchase");
  }
};

export const calculateDonation = async (
  price: number,
  country: string
): Promise<DonationResponse> => {
  try {
    const response = await pricingApi.post<DonationResponse>("/api/donation", {
      price,
      country,
    });
    return response.data;
  } catch (error) {
    console.error("Error calculating donation", error);
    throw new Error("Failed to calculate donation");
  }
};

export const validateTransaction = async (
  token: string,
  paymentId: string,
  transactionType: "purchase" | "donation"
): Promise<PurchaseResponse | DonationResponse> => {
  try {
    const response = await pricingApi.post<PurchaseResponse | DonationResponse>(
      "/api/pricing/validate",
      {
        token,
        payment_id: paymentId,
        transaction_type: transactionType,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error validating transaction token", error);
    throw new Error("Failed to validate transaction token");
  }
};
